import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import "./spellcheckstyle.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import fav_icon from "./../Asset/New_Assert/ESO_ICON.png";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import LiquidFillGauge from "react-liquid-gauge";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { faLaptopHouse } from "@fortawesome/free-solid-svg-icons";
import wordwrap from "wordwrapjs";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import RunReportNow from "../RunReportNow";
import { Helmet } from "react-helmet";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../Context/Context";
import { Commonfun, removeDuplicateDate } from "./../Commonfun";
import { timezonechange } from "./../Commonfun";
import { timezoneval } from "./../Commonfun";
import { datezonechange } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import Loader from "../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import PdfandCsv from "../PdfandCsv";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Container, Grid } from '@mui/material/';

export default function Spellcheckerlist() {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [jobidValue, setjobValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [value, onChange] = React.useState();
  const [valueOutside, onChangeOutsidde] = React.useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([]);
  const [Domainsectiondata, SetDomainsectiondata] = useState([]);
  const [initialDateval, SetInitialDateval] = useState([]);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [faqData, setfaqData] = useState("2");
  const [toggle, setToggle] = useState(false);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [spellCheckerPlan, setspellCheckerPlan] = useState({
    status: true,
    error: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({
    name: "",
    path: "",
    closeName: "Close",
    statusDomain: false,
  });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({
    domain_name: "",
    domain_url: "",
  });

  const navigate = useNavigate();
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at: "Select Date",
    id: "Select Date",
  });

  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at: "Select Date",
    id: "Select Date",
  });
  const [tableLoading, setTableLoading] = useState(true);

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;

  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let errors = { ...validation };
  let subtitle;
  let detailurl = `${process.env.REACT_APP_DOMAIN}spell-checker-detail/`;

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const checkUserPlan = async () => {

    const spellCheckerP = await Utils("spell_checker", ApiToken);

    if (spellCheckerP.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
      faqdatafun();
    }
    setspellCheckerPlan(spellCheckerP);
  };

  const arr = [];

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios
        .get(`${process.env.REACT_APP_API_URL}accounts/get_user_details/`, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 500 ||
            error?.response?.status == 400 ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({
          ...domainNameUrl,
          domain_name: datavalue?.data?.dor_domain_name,
          domain_url: datavalue?.data?.dor_domain_url,
        });
      }
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({
            ...first,
            name: "Verify Now",
            path: "/Userdata",
            statusDomain: true,
          });
          return;
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({
            ...first,
            name: "Verify Now",
            path: "/Impadddomain",
            statusDomain: true,
          });
          return;
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({
            ...first,
            name: "Verify Now",
            path: "/Domainownership",
            statusDomain: true,
          });
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [


    {
      field: "link__url",
      headerName: "URL",
      description: "URL for which the spell check has been accomplished.",
      minWidth: 350,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        let baseUrl =
          cardData.row.link__url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.link__url.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData?.row?.link__url}>
              <div className="prefered_url_external02">
                <a
                  className="table_links"
                  target="_blank"
                  href={cardData?.row?.link__url}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink">{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "sentences_with_suggestions_count",
      headerName: "Number of Sentences with Suggestions",
      description: "Total number of sentences from the page where spelling suggestions were made.",
      minWidth: 270,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
    },
    {
      field: "View",
      headerName: "View",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",
      renderCell: (cardData) => {
        return (
          <a href={detailurl + `${cardData.row.id}` + "/" + jobidValue}>
            <button className="view-report-button">View Report</button>
          </a>
        );
      },
    },
  ];

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "", domainsecdata = "") => {
    setLoading(true);
    setTableLoading(true);
    // if (domainsecdata == "") domainsecdata = Domainsectiondata;
    if (jobid == "") jobid = jobidData;
    const datavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}&domain_section_id=${domainsecdata}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        },
      )
      .catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (
          error?.code == "ERR_NETWORK" ||
          error?.response?.status == 404
        ) {
          navigate("/errorpages");
        }
      });

    const completevalues = await axios
      .get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=new_spell_checker&user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        },
      )
      .catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (
          error?.code == "ERR_NETWORK" ||
          error?.response?.status == 404
        ) {
          navigate("/errorpages");
        }
      });
    // var Selectedmets = [];
    // completevalues?.data?.jobs.forEach((element) => {
    //   Selectedmets.push({
    //     value: element?.id,
    //     label: datezonechange(element?.completed_at),
    //   });
    // });
    const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
    if (datavalue?.data?.job_date)
      setjobDate(
        moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"),
      );
    else setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));
    if (uniqueByCompletedAt.length != 0) {
      SetInitialDateval(uniqueByCompletedAt[0]);
      if (jobidData == "") {
        setSelectval(uniqueByCompletedAt);
        if (dEngineoption.completed_at === "Select Date") {
          SetdEngineoption([uniqueByCompletedAt[0]]);
          setprevdEngineoption([uniqueByCompletedAt[0]]);
        }
      }
      setcompletedate(uniqueByCompletedAt);

      setjobValue(datavalue?.data?.job_id);
    }
    const dataval = datavalue?.data?.table_data;

    if (dataval && dataval.length > 0) {
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
      SetAutoheightval(false);
    } else {
      setCardData("");
      SetAutoheightval(true);
      //  setTableLoading(true);

    }

    setLoading(false);
    setTableLoading(false);
  };

  const reportNow = async () => {
    var errs = 1;
    let errors = {};

    if (!selectval || selectval.value == "") {
      errors.dateerror = "This field is required.";
      errs = 2;
    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
      setLoading(true);
      setjobidData(selectval.value);
      setIsOpen(false);
      setprevdEngineoption(dEngineoption);
      setjobValue(selectval.value);
      var domainsec = "";
      callUserdataApi(selectval.value, (domainsec = ""));
    }
    if (errs == 2) {
      return setValidation(errors);
    }
  };
  function openModal() {
    setfaqData(2);
    setToggle(false);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }
  const [RunReportPopShow, SetRunReportPopShow] = useState(false);
  const [RunReportType, SetRunReportType] = useState("new_spell_checker");
  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidValue}&is_format=pdf&timezone=${timezoneval()}&domain_section_id=${Domainsectiondata}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun(
          "Spellchecker",
          "pdf",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloading(false);
  };
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidValue}&is_format=csv&timezone=${timezoneval()}&domain_section_id=${Domainsectiondata}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun(
          "Spellchecker",
          "csv",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  };
  const LoadAddFormFilterOptions = async () => {
    SetSectionOptions([]);
    try {
      const doaminsectiondatavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}domain/get_domain_sections/?user_domain_id=${esodata.domaindata.value.header_selected}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        if (doaminsectiondatavalue?.data?.domain_sections) {
          SetDoaminSectionUrl(doaminsectiondatavalue.data.domain_sections);
          var Sections = [];
          doaminsectiondatavalue.data.domain_sections.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetSectionOptions(Sections);
        }
      }
    } catch (err) { }
  };
  const SetSectionNameHandle = (passvalue) => {
    if (passvalue) {
      SetDomainsectiondata(passvalue.value);
      callUserdataApi("", passvalue.value);
    } else {
      SetDomainsectiondata("")
      callUserdataApi();
    }
  };
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=65`;

    try {
      const doaminsectiondatavalue = await axios.get(datavar, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);
  };
  const e = document.getElementById("root");
  e.addEventListener("click", function handleClick(event) {
    if (
      event.target.classList[0] === "cnt_hdr_blw_wrap" ||
      event.target.classList[0] === "header_wrap" ||
      event.target.classList[0] === "nav_key_txt" ||
      event.target.classList[0] === "cnt_hdr_top_wrap" ||
      event.target.classList[0] === "react-dropdown-select" ||
      event.target.classList[0] === "react-dropdown-select-content" ||
      event.target.classList[0] === "react-dropdown-select-item" ||
      event.target.classList[0] === "site_cnt_hdr_blw_wrap" ||
      event.target.classList[0] === "App" ||
      event.target.classList[0] === "cnt_audit_outer_wrap" ||
      event.target.classList[0] === "MuiDataGrid-columnHeaderTitleContainer" ||
      event.target.classList[0] === "MuiDataGrid-toolbarContainer" ||
      event.target.classList[0] === "MuiDataGrid-row" ||
      event.target.classList[0] === "MuiDataGrid-cell" ||
      event.target.classList[0] === "MuiDataGrid-cellContent" ||
      event.target.classList[0] === "header_inner_btm_wrap" ||
      event.target.classList[0] === "over_all_container" ||
      event.target.classList[0] === "input_domain_field" ||
      event.target.classList[0] === "react-dropdown-select-input"
    ) {
      setfaqData(2);
      setToggle(false);
    }
  });
  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }
  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }


  return (
    <div
      className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Spell Checker Report</title>
      </Helmet>

      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {loading === true ? <Loader /> : null}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Spell Checker Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Content' },
                      { title: 'Spell Checker', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button">
                <Select
                  options={SectionOptions}
                  name="name"
                  onChange={SetSectionNameHandle}
                  placeholder="Domain Section"
                  isClearable
                  styles={customDropdownStyles()}
                  menuPortalTarget={document.body}
                  classNamePrefix="common-domain-dropdown_color"
                />
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => {
                    if (first.statusDomain) {
                      setcheckD(first.statusDomain);
                    } else {
                      setfaqData(2);
                      setToggle(false);
                      SetRunReportPopShow(true);
                    }
                  }}
                >
                  Run Report Now
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {spellCheckerPlan.status ? (
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={true}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                ) : (
                  <Freeaudit planStatus={spellCheckerPlan} />
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <div>
        <div className="cnt_audit_outer_wrap">
          {toggle && (
            <Rightsidebar
              close={() => setToggle(false)}
              setToggle={setToggle}
              initialfaqDateval={initialfaqDateval}
            />
          )}
          <Dialog
            open={modalIsOpen}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="competitor_test_filter job_date_filter"
          >
            <DialogTitle className="keyword-dialog-header">
              {"Filter By"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <div className="cnt_hdr_blw_wrap row">
                  <div>
                    <div className="">
                      <div>
                        <span>Completed Date</span>
                        <Select
                          value={dEngineoption}
                          options={completedate}
                          placeholder="Select..."
                          onChange={(values) => {
                            setSelectval(values);
                            SetdEngineoption(values);
                          }}
                          styles={customDropdownStyles()}
                          menuPortalTarget={document.body}
                        />
                      </div>
                    </div>

                    <div className="col">
                      <span className="text-error">{validation.dateerror}</span>
                    </div>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-button">
              <button
                className="form_submit_btn"
                onClick={reportNow}
                style={{ cursor: "pointer" }}
              >
                Submit
              </button>
              <button style={{ cursor: "pointer" }} onClick={closeModal}>
                close
              </button>
              <button
                className="form_submit_btn"
                style={{ cursor: "pointer" }}
                onClick={handleReset}
              >
                Reset
              </button>
            </DialogActions>
          </Dialog>

          {!openCommonAlerts &&
            <>
              <CommonErrorAlert
                data={{
                  apiopen: open,
                  apiErrorMsg: 'No Data Found',
                  isIconStyled: true
                }}
                closeAlert={handleClose} />

              <CommonErrorAlert
                data={{
                  apiopen: apiopen,
                  apiErrorMsg: apierrorMsg,
                  isIconStyled: true
                }}
                closeAlert={apihandleClose} />
            </>
          }
          <Dialog
            open={checkD}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="domain-verify-alert"
          >
            <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "15px",
                    lineHeight: "1px",
                    width: "max-content",
                  }}
                >
                  <p>{`Please verify your domain ${domainNameUrl.domain_name} to access these features`}</p>
                  <a href={domainNameUrl.domain_url}>
                    {domainNameUrl.domain_url}
                  </a>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-button">
              <Button
                onClick={() => {
                  navigate(first.path);
                }}
              >
                {first.name}
              </Button>
              <Button onClick={() => setcheckD(false)}>
                {first.closeName}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
      />
    </div>
  );
}
